import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Home } from 'react-feather';
import { Link } from 'react-router-dom';

const Breadcrumbs = (props) => {
  return (
    <>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="6"></Col>
            <Col xs="6">
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/project/list`}>
                    <Home />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/${props.url}`}>{props.parent}</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>{props.title}</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Breadcrumbs;
